import HeaderSkeleton, { type OwnProps as HeaderProps } from '@carvana/header';
import { usePrevious } from '@carvana/merch-react-hooks';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useContext, useMemo, useEffect } from 'react';
import { commonEnvironment } from '~/constants/environment';
import FavoritesContext from '~/contexts/FavoritesContext';
import StaticContext from '~/contexts/StaticContext';
import { useUserData } from '~/contexts/UserContext';
import useClientSide from '~/hooks/useClientSide';
import { loadHeaderMfe } from '~/utilities/MicroFrontEnds';

function useShouldRefreshProfile() {
  const { isLoggedIn } = useUserData();

  return usePrevious(isLoggedIn) !== isLoggedIn;
}

export default function Header() {
  const isClientSide = useClientSide();
  const { favorites: userFavorites } = useContext(FavoritesContext);
  const { serverCookies } = useContext(StaticContext);
  const shouldRefreshProfile = useShouldRefreshProfile();

  const favorites = useMemo(
    () => ({ favorites: userFavorites }),
    [userFavorites]
  );

  useEffect(() => {
    void loadHeaderMfe();
  }, []);

  const props: HeaderProps = {
    cookies: serverCookies,
    environment: commonEnvironment,
    favorites,
    shouldLoadPlugin: false,
    shouldRefreshProfile,
    useProvider: true,
    route: '/cars'
  };

  return isClientSide ? (
    <MfeReactComponent
      component="default"
      fallback={{
        Component: <HeaderSkeleton {...props} />,
        timeout: 30000
      }}
      loading={<HeaderSkeleton {...props} />}
      module="HeaderModule"
      {...props}
    />
  ) : (
    <HeaderSkeleton {...props} />
  );
}
